@if (application(); as application) {
  @switch (true) {
    @case (tag === 'investor') {
      @if (application?.investorDataSameAsApplicant) {
        <div class="row">
          <div class="col-12">
            <app-label [label]="'Dane są takie same jak dane wnioskodawcy:'">
              Tak
            </app-label>
          </div>
        </div>
      } @else {
        <app-contractors-preview
          noDataInfo="Brak dodanych wnioskodawców!"
          [contractors]="contractors()"
          [expanded]="expanded"
          [showActions]="false">
        </app-contractors-preview>
      }
    }
    @case (tag === 'performer') {
      @if (application?.performerDataSameAsApplicant) {
        <div class="row">
          <div class="col-12">
            <app-label [label]="'Dane są takie same jak dane wnioskodawcy:'">
              Tak
            </app-label>
          </div>
        </div>
      } @else {
        <app-contractors-preview
          noDataInfo="Brak dodanych wnioskodawców!"
          [contractors]="contractors()"
          [expanded]="expanded"
          [showActions]="false">
        </app-contractors-preview>
      }
    }
    @default {
      @if (application?.investorDataSameAsApplicant) {
        <div class="row">
          <div class="col-12">
            <app-label [label]="'Dane są takie same jak dane wnioskodawcy:'">
              Tak
            </app-label>
          </div>
        </div>
      } @else {
        <app-contractors-preview
          noDataInfo="Brak dodanych wnioskodawców!"
          [contractors]="contractors()"
          [expanded]="expanded"
          [showActions]="false">
        </app-contractors-preview>
      }
    }
  }

}
